module.exports = __webpack_public_path__ + "static/media/1-river-07_04_2020.24a38b00.jpg";